module.exports = __webpack_public_path__ + "img/Bancolombia.26190d27.png";